export const ADD_ATTACHMENT_ENQUIRY = "ADD_ATTACHMENT_ENQUIRY";
export const ADD_ATTACHMENT_ENQUIRY_SUCCESS = "ADD_ATTACHMENT_ENQUIRY_SUCCESS";
export const ADD_ATTACHMENT_ENQUIRY_FAILURE = "ADD_ATTACHMENT_ENQUIRY_FAILURE";
export const RESET_ATTACHMENT_ENQUIRY = "RESET_ATTACHMENT_ENQUIRY";

export const addAttachmentEnquiryRequest = (data: any) => ({
    type: ADD_ATTACHMENT_ENQUIRY,
    payload: data,
});

export const addAttachmentEnquirySuccess = (data: any) => ({
    type: ADD_ATTACHMENT_ENQUIRY_SUCCESS,
    payload: data,
});

export const addAttachmentEnquiryFailure = (error: any) => ({
    type: ADD_ATTACHMENT_ENQUIRY_FAILURE,
    payload: error,
});

export const resetAttachmentEnquiry = () => ({
    type: RESET_ATTACHMENT_ENQUIRY,
});

export const GET_ATTACHMENT_ENQUIRY = "GET_ATTACHMENT_ENQUIRY";
export const GET_ATTACHMENT_ENQUIRY_SUCCESS = "GET_ATTACHMENT_ENQUIRY_SUCCESS";
export const GET_ATTACHMENT_ENQUIRY_FAILURE = "GET_ATTACHMENT_ENQUIRY_FAILURE";
export const RESET_GET_ATTACHMENT_ENQUIRY = "RESET_GET_ATTACHMENT_ENQUIRY";

export const getAttachmentEnquiryRequest = (params: any) => ({
    type: GET_ATTACHMENT_ENQUIRY,
    payload: params,
});

export const getAttachmentEnquirySuccess = (data: any) => ({
    type: GET_ATTACHMENT_ENQUIRY_SUCCESS,
    payload: data,
});

export const getAttachmentEnquiryFailure = (error: any) => ({
    type: GET_ATTACHMENT_ENQUIRY_FAILURE,
    payload: error,
});

export const resetGetAttachmentEnquiry = () => ({
    type: RESET_GET_ATTACHMENT_ENQUIRY,
});